var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-sheet',{attrs:{"width":"100%","height":"100%","color":"blue"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://landlords.bremertonwa.gov/#/loggedin","frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }